<template>
  Hello, I am Aryeh.
  <br />
  <a href="https://x.com/aryeh_greenberg">Twitter</a>
  <br />
  <a href="mailto:aryeh@aryehgreenberg.com">Email</a>
</template>
